export * from './lib/feature-guard.module';
